import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { putDataWAuth } from "../../../utils/api-service";
import { EXTENSION_APPROVE, EXTENSION_REJECT } from "../../../constants/constant";

export const approveRequest = createAsyncThunk(
  "actionsExtension/approveRequest",
  async ({ id, requestStatus, view }, { rejectWithValue }) => {
    try {
      await putDataWAuth(EXTENSION_APPROVE, { id, requestStatus });
      return { id, view };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to approve request");
    }
  }
);

export const rejectRequest = createAsyncThunk(
  "actionsExtension/rejectRequest",
  async ({ id, requestStatus, view }, { rejectWithValue }) => {
    try {
      await putDataWAuth(EXTENSION_REJECT, { id, requestStatus });
      return { id, view };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Failed to reject request");
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  lastActionResult: null,
};

const actionsExtensionSlice = createSlice({
  name: "actionsExtension",
  initialState,
  reducers: {
    clearActionError: (state) => {
      state.error = null;
    },
    clearLastActionResult: (state) => {
      state.lastActionResult = null;
    },
    resetActions: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(approveRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.lastActionResult = { type: 'approve', ...action.payload };
      })
      .addCase(approveRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder
      .addCase(rejectRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(rejectRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.lastActionResult = { type: 'reject', ...action.payload };
      })
      .addCase(rejectRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearActionError,
  clearLastActionResult,
  resetActions,
} = actionsExtensionSlice.actions;

export default actionsExtensionSlice.reducer;
